import { render, staticRenderFns } from "./Configdetails.vue?vue&type=template&id=7734fe54&scoped=true"
import script from "./Configdetails.vue?vue&type=script&lang=js"
export * from "./Configdetails.vue?vue&type=script&lang=js"
import style0 from "./Configdetails.vue?vue&type=style&index=0&id=7734fe54&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7734fe54",
  null
  
)

export default component.exports